import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Zh from './languages/cn'
import En from './languages/en'
// import {
//   LANG_KEY
// } from '@/utils/common'


Vue.use(VueI18n)


const messages = {
  en: En,
  zh: Zh
}

// let lang = localStorage.getItem(LANG_KEY) || 'zh'
let lang = 'zh';
export const i18n = new VueI18n({
  locale: lang, // set locale 默认显示英文
  fallbackLocale: 'zh', //没有英文的时候默认中文语言
  silentFallbackWarn: true, //抑制警告
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages
  // messages: {
  //   'cn': require('./languages/cn'), //中文繁体语言包
  //   'en': require('./languages/cn') // 英文语言包
  // }
})